export const IMPORT_SURVEYS = 'IMPORT_SURVEYS';
